import { ReactComponent as RemoveSvg } from './svg/remove.svg'

const RemoveIcon = ({ fill = '#FFFFFF', ...props }) => (
  <RemoveSvg fill={fill} {...props} />
)

export default RemoveIcon
